var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html } from 'lit';
import { property, state } from 'lit/decorators.js';
import { guard } from 'lit/directives/guard.js';
import { SdsTreeNodeBase } from './_sds-tree-node-base';
/**
 * Base for tree data node. Data node is the node that contains cells.
 */
let SdsTreeDataNodeBase = (() => {
    var _a, _SdsTreeDataNodeBase_identifier_accessor_storage, _SdsTreeDataNodeBase_slotStyles_accessor_storage;
    let _classSuper = SdsTreeNodeBase;
    let _identifier_decorators;
    let _identifier_initializers = [];
    let _identifier_extraInitializers = [];
    let _slotStyles_decorators;
    let _slotStyles_initializers = [];
    let _slotStyles_extraInitializers = [];
    return _a = class SdsTreeDataNodeBase extends _classSuper {
            constructor() {
                super(...arguments);
                _SdsTreeDataNodeBase_identifier_accessor_storage.set(this, __runInitializers(this, _identifier_initializers, void 0));
                _SdsTreeDataNodeBase_slotStyles_accessor_storage.set(this, (__runInitializers(this, _identifier_extraInitializers), __runInitializers(this, _slotStyles_initializers, {
                    display: 'inherit',
                })));
                this.freezeOnDocumentDirectionChange = (__runInitializers(this, _slotStyles_extraInitializers), () => {
                    this.freezeColumns(this.frozenColumns);
                });
            }
            /**
             * Unique identifier that is used to identify the node in the tree.
             */
            get identifier() { return __classPrivateFieldGet(this, _SdsTreeDataNodeBase_identifier_accessor_storage, "f"); }
            set identifier(value) { __classPrivateFieldSet(this, _SdsTreeDataNodeBase_identifier_accessor_storage, value, "f"); }
            /**
             * The style for the `nodes` slot. This is used to toggle visibility of the child nodes.
             */
            get slotStyles() { return __classPrivateFieldGet(this, _SdsTreeDataNodeBase_slotStyles_accessor_storage, "f"); }
            set slotStyles(value) { __classPrivateFieldSet(this, _SdsTreeDataNodeBase_slotStyles_accessor_storage, value, "f"); }
            async connectedCallback() {
                var _b, _c, _d;
                await super.connectedCallback();
                if (!((_b = this.tree) === null || _b === void 0 ? void 0 : _b.state.hasListener('documentDirection', this.freezeOnDocumentDirectionChange))) {
                    (_d = (_c = this.tree) === null || _c === void 0 ? void 0 : _c.state) === null || _d === void 0 ? void 0 : _d.addListener('documentDirection', this.freezeOnDocumentDirectionChange);
                }
            }
            disconnectedCallback() {
                var _b, _c;
                super.disconnectedCallback();
                (_c = (_b = this.tree) === null || _b === void 0 ? void 0 : _b.state) === null || _c === void 0 ? void 0 : _c.removeListener('documentDirection', this.freezeOnDocumentDirectionChange);
            }
            customStyles() {
                return undefined;
            }
            render() {
                var _b;
                const treeNode = this.nodeId !== undefined
                    ? (_b = this.tree) === null || _b === void 0 ? void 0 : _b.hierarchicalState.getNode(this.nodeId)
                    : undefined;
                return html `
            ${this.customStyles()}
            ${guard([this.level, this.documentDir, this.frozenColumns, this.isLeaf], () => this.levelStyles(this.level, this.documentDir, this.frozenColumns, this.isLeaf))}
            ${guard([this.level, this.documentDir], () => this.pathStyles(this.level, this.documentDir))}
            ${this.level === 1
                    ? this.renderSinglePath(this.isCollapsed, this.isLeaf)
                    : this.renderPassingNode(treeNode, this.isLeaf, this.isCollapsed)}
            ${this.level === 1 && this.isLeaf
                    ? html ` <div class="sds-tree-inner-column"></div>`
                    : this.isLeaf
                        ? guard([], () => this.renderLeafIcon())
                        : guard([this.isCollapsed], () => this.renderNodeControl(this.isCollapsed))}
            ${this.renderData()} ${this.renderNodes()}
        `;
            }
            changeFrozenColumns(newValue) {
                if (this.frozenColumns !== 0) {
                    this.unFreezeAllColumns();
                }
                if (newValue !== 0) {
                    this.freezeColumns(newValue);
                }
                super.changeFrozenColumns(newValue);
            }
            renderPassingNode(treeNode, isLeaf, isCollapsed) {
                return html `${this.renderPassingPaths(treeNode)} ${this.renderPathEnd(isLeaf, isCollapsed)} `;
            }
        },
        _SdsTreeDataNodeBase_identifier_accessor_storage = new WeakMap(),
        _SdsTreeDataNodeBase_slotStyles_accessor_storage = new WeakMap(),
        (() => {
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _identifier_decorators = [property({ type: String })];
            _slotStyles_decorators = [state()];
            __esDecorate(_a, null, _identifier_decorators, { kind: "accessor", name: "identifier", static: false, private: false, access: { has: obj => "identifier" in obj, get: obj => obj.identifier, set: (obj, value) => { obj.identifier = value; } }, metadata: _metadata }, _identifier_initializers, _identifier_extraInitializers);
            __esDecorate(_a, null, _slotStyles_decorators, { kind: "accessor", name: "slotStyles", static: false, private: false, access: { has: obj => "slotStyles" in obj, get: obj => obj.slotStyles, set: (obj, value) => { obj.slotStyles = value; } }, metadata: _metadata }, _slotStyles_initializers, _slotStyles_extraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        })(),
        _a;
})();
export { SdsTreeDataNodeBase };
